import { Avatar } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useAccountContext } from "@root/stores/accountStore";

type UserAvatarProps = {
  fallbackText?: string;
  imageUrl?: string;
  useStore?: boolean; // If true, read from store instead of props
};
export const UserAvatar = observer(
  ({ fallbackText, imageUrl, useStore = false }: UserAvatarProps) => {
    // Always call the hook, but only use it if useStore is true
    const accountStore = useAccountContext();

    // If useStore is true, get values from store, otherwise use props
    // Access session properties directly to ensure MobX tracks them
    const session = useStore ? accountStore?.session : null;
    const displayFallbackText =
      useStore && session ? session.initials : fallbackText;
    const displayImageUrl = useStore && session ? session.imageUrl : imageUrl;

    return (
      <Avatar
        component={"div"}
        src={displayImageUrl}
        key={
          useStore
            ? `avatar-${session?.id}-${accountStore?.sessionVersion}`
            : undefined
        }
        slotProps={{
          img: {
            sx: { width: "2.5rem", height: "2.5rem" },
          },
        }}
        sx={(theme) => ({
          backgroundColor: displayImageUrl
            ? "inherit"
            : theme.palette.primary.main,
          width: "2.5rem",
          height: "2.5rem",
          fontSize: "1rem",
        })}
      >
        {displayFallbackText}
      </Avatar>
    );
  }
);
